import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { HotelStateType } from './types';

const initialState: HotelStateType = {};

const hotelSlice = createSlice({
  name: 'hotel',
  initialState,
  reducers: {
    setHotelLabels: (
      state: HotelStateType,
      action: PayloadAction<unknown>,
    ) => ({
      ...(typeof state.toJS === 'function' ? state.toJS() : state),
      labels: action.payload,
    }),
    setMetapolicies: (
      state: HotelStateType,
      action: PayloadAction<unknown>,
    ) => ({
      ...(typeof state.toJS === 'function' ? state.toJS() : state),
      metapolicies: action.payload,
    }),
  },
});

export const { setHotelLabels, setMetapolicies } = hotelSlice.actions;
export const hotelReducer = hotelSlice.reducer;
